import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M11 20H4C3.45 20 2.975001 19.8083 2.575001 19.425C2.191667 19.025 2 18.55 2 18V7H4V18H11V20ZM7.5 6C6.95 6 6.475 5.80833 6.075 5.425C5.69167 5.025 5.5 4.55 5.5 4C5.5 3.45 5.69167 2.983333 6.075 2.599999C6.475 2.2 6.95 2 7.5 2C8.05 2 8.51667 2.2 8.9 2.599999C9.3 2.983333 9.5 3.45 9.5 4C9.5 4.55 9.3 5.025 8.9 5.425C8.51667 5.80833 8.05 6 7.5 6ZM12 22V17H7C6.45 17 5.975 16.8083 5.575 16.425C5.19167 16.025 5 15.55 5 15V9.5C5 8.8 5.24167 8.20833 5.725 7.725C6.20833 7.24167 6.8 7 7.5 7C8.2 7 8.79167 7.24167 9.275 7.725C9.75833 8.20833 10 8.8 10 9.5V14H12C12.55 14 13.0167 14.2 13.4 14.6C13.8 14.9833 14 15.45 14 16V22H12Z" />
    <path d="M21.9999 11V13H18.9999V22H16.9999V13L14 13V11C14 11 19.7123 11 21.9999 11Z" />
  </>,
  'Seating',
)
